(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('IntegracaoParceiro', IntegracaoParceiro);

    IntegracaoParceiro.$inject = ['$http'];

    function IntegracaoParceiro($http) {
        var resourceUrl = 'api/integracao-parceiros';

        var service = {
            query: query,
            get: get,
            create: create,
            update: update,
            remove: remove
        };

        return service;

        function query() {
            return $http.get(resourceUrl);
        }

        function get(id) {
            return $http.get(resourceUrl + '/' + id);
        }

        function create(body) {
            return $http.post(resourceUrl, body);
        }

        function update(id, body) {
            return $http.put(resourceUrl + '/' + id, body);
        }

        function remove(id) {
            return $http.delete(resourceUrl + '/' + id);
        }
    }
})();
